import BasicDateInput from "components/BasicInputs/BasicDateInput";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import WarningBox from "components/WarningBox/WarningBox";
import React, { useState } from "react";
import { useSelector } from "react-redux";

type Props = {
  settingData: any;
  setSettingData: any;
};

function FiscalYear({ settingData, setSettingData }: Props) {
  // fiscalYearTitle
  const onChange = (key: any, value: any) => {
    let temp = {
      ...settingData,
      [key]: value,
    };
    setSettingData(temp);
  };
  //@ts-ignore
  const businessState = useSelector((state) => state).appReducer;
  //@ts-ignore
  const isGer = useSelector((state) => state).businessReducer;
  const [showWarningBox, setShowWarningBox] = useState(false);
  return (
    <div className="flex container flex-col">
      <div className="flex w-full gap-6 flex-row item-center">
        <BasicTextInput
          style={{ padding: "10px 12px" }}
          fullWidth
          val={businessState?.fiscalYear?.name ?? ""}
          onChange={(value) => {
            //@ts-ignore
            // setTitle(value?.toString());
            onChange("fiscalYearTitle", value);
          }}
          label="عنوان سال مالی"
          disabled
        />
        <div className="flex flex-row gap-3 w-full">
          <BasicDateInput
            disable
            defaultValues={[businessState?.fiscalYear?.start_date] ?? ""}
            label="تاریخ شروع"
            onChange={(value) => {
              onChange("startDate", value);
            }}
            isGregorian={isGer.businesses[0].is_gregorian}
          />
          <BasicDateInput
            disable
            defaultValues={[businessState?.fiscalYear?.end_date] ?? ""}
            label="تاریخ پایان"
            onChange={(value) => {
              onChange("endDate", value);
            }}
            isGregorian={isGer.businesses[0].is_gregorian}
          />
        </div>
      </div>
      {showWarningBox && (
        <WarningBox
          type="info"
          title={" در نظر داشته باشید مقادیر سال مالی نمی تواند از تاریخ های گذشته باشد"}
          description="چنانچه مقادیر شروع و پایان سال مالی را در بازه های گذشته انتخاب کنید "
          onClose={() => {
            setShowWarningBox(false);
          }}
        />
      )}
    </div>
  );
}

export default FiscalYear;
